import './src/styles/global.css'
import './src/styles/reveal.css'
import '@fontsource/chivo-mono'
import '@fontsource/raleway/700.css'
import '@fontsource/inter'
import '@fontsource/inter/700.css'

// gatsby-plugin-react-i18next falls back to browser-language detection when no
// stored choice exists, which redirects first-time visitors to /en/ after the
// Estonian page has already painted. Seeding the stored language with the site
// default keeps the first load on Estonian; an explicit pick in the language
// switcher overwrites this key and is honored on return visits.
// Keep the current scroll position when the navigation was a language switch
// (both language versions of the page have the same layout).
export const shouldUpdateScroll = ({routerProps: {location}}) => {
    if (location.state && location.state.preserveScroll) {
        return false
    }
    return true
}

export const onClientEntry = () => {
    const LANGUAGE_KEY = 'gatsby-i18next-language'
    if (!window.localStorage.getItem(LANGUAGE_KEY)) {
        window.localStorage.setItem(LANGUAGE_KEY, 'et')
    }
}
